import { Heading2, TextBodySmall } from '@components/TextStyles'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import styled from 'styled-components'

export const MigrationModalWrapper = styled.div`
  background-color: ${colors.grey};
  border-radius: 2.4rem;
  padding: 3.4rem;
  position: relative;
  text-align: center;
  max-width: 90rem;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MigrationModalHeading = styled(Heading2)`
  max-width: 15ch;
  position: relative;

  ${mq.tabletL} {
    max-width: none;
  }
`

export const MigrationModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${clamp('gap', 8, 16)}

  ${mq.tabletL} {
    flex-direction: row;
  }
`

export const MigrationModalCloseButton = styled.button`
  appearance: none;
  background-color: ${colors.grey};
  border: #4b4b63 solid 7px;
  border-radius: 50%;
  cursor: pointer;
  padding: 1.2rem;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(40%, -40%);

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }
`

export const MigrationModalDisclaimer = styled(TextBodySmall)`
  font-size: 1.4rem;
`
